import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";


import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";

const DcPendingView_Report = () => {
  useAuthRedirect();
  const [data, setData] = useState([]);
  const branch = localStorage.getItem("branch");
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);
  const [selectedType, setSelectedType] = useState("Returnable");

  const canView  = hasPermission("D.C - Pending", "view");

  useEffect(() => {
    fetchData();
  }, [selectedType]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        "https://rfs2.infraconsoft.net.in/api/dcPendingList_report",
        {
          params: { type: selectedType, branch: branch },
        }
      );

      const rawData = response.data.purchaseOrderList;

      // Group by DC No
      const grouped = rawData.reduce((acc, row) => {
        const dcNo = row.DcDetail_Number;
        if (!acc[dcNo]) {
          acc[dcNo] = {
            DcDetail_Number: dcNo,
            DcHeader_date: row.DcHeader_date,
            dcheader_yourReferenceNumber: row.dcheader_yourReferenceNumber,
            items: [],
          };
        }
        acc[dcNo].items.push({
          itemCode: row.dcDetail_itemcode,
          drawingNo: row.itemmaster_drawingNumber,
          name: row.itemMaster_name,
          uom: row.itemmaster_uom,
          refNo: row.DcDetail_referrence,
          qty: row.DcDetail_quantity,
          received: row.DcDetail_receivedQuantity,
          dueDate: row.dcdetail_dueDate,
        });
        return acc;
      }, {});
      const finalData = Object.values(grouped);

      setData(finalData);
      setFilteredData(finalData);
    } catch (error) {
      console.error("Error fetching purchaseOrderList:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);

    if (term === "") {
      setFilteredData(data);
      return;
    }

    const filtered = data.filter(
      (dc) =>
        String(dc.DcDetail_Number || "").toLowerCase().includes(term) ||
        dc.items.some((item) =>
          String(item.name || "").toLowerCase().includes(term)
        )
    );

    setFilteredData(filtered);
  };

  // Pagination
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  if (!canView) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }

  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
          <h2 className="add-txt">D.C Pending View</h2>
          <Time />
        </section>

        {/* Type Selection */}
        <div className="month-year-container">
          <p className="title">Type</p>
          <div className="select-container">
            <select
              value={selectedType}
              onChange={(e) => setSelectedType(e.target.value)}
              className="custom-select"
              style={{ width: "170px" }}
            >
              <option value="Returnable">Returnable</option>
              <option value="Customer-Properties">Customer-Properties</option>
            </select>
          </div>
        </div>

        {/* Search Filter */}
        <div className="search-filter">
          <p>Search: </p>
          <input
            type="text"
            placeholder="Search by DC No / Item Name"
            value={searchTerm}
            onChange={handleSearch}
            className="search-input"
          />
        </div>

        {/* Table */}
        <div className="content-table">
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th>D.C No</th>
                <th>Date</th>
                <th>Ref No.</th>
                <th>Item</th>
                <th>Drawing No</th>
                <th>Name</th>
                <th>UOM</th>
                <th>CSP/Ref.</th>
                <th>D.C Qty</th>
                <th>Pending Qty</th>
                <th>Due Date</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="12" className="loading-text">
                    Loading data, please wait...
                  </td>
                </tr>
              ) : currentData.length > 0 ? (
                currentData.map((dc, dcIndex) => (
                  <React.Fragment key={dcIndex}>
                    <tr className="dc-header-row">
                      <td rowSpan={dc.items.length}>
                        {indexOfFirstItem + dcIndex + 1}
                      </td>
                      <td rowSpan={dc.items.length}>{dc.DcDetail_Number}</td>
                      <td rowSpan={dc.items.length}>
                        {new Date(dc.DcHeader_date).toLocaleDateString()}
                      </td>
                      <td rowSpan={dc.items.length}>
                        {dc.dcheader_yourReferenceNumber}
                      </td>

                      {/* first item */}
                      <td>{dc.items[0].itemCode}</td>
                      <td>{dc.items[0].drawingNo}</td>
                      <td>{dc.items[0].name}</td>
                      <td>{dc.items[0].uom}</td>
                      <td>{dc.items[0].refNo}</td>
                      <td>{dc.items[0].qty}</td>
                      <td>{dc.items[0].qty - dc.items[0].received}</td>
                      <td>
                        {dc.items[0].dueDate
                          ? new Date(dc.items[0].dueDate).toLocaleDateString()
                          : "-"}
                      </td>
                    </tr>

                    {dc.items.slice(1).map((it, i) => (
                      <tr key={i}>
                        <td>{it.itemCode}</td>
                        <td>{it.drawingNo}</td>
                        <td>{it.name}</td>
                        <td>{it.uom}</td>
                        <td>{it.refNo}</td>
                        <td>{it.qty}</td>
                        <td>{it.qty - it.received}</td>
                        <td>
                          {it.dueDate
                            ? new Date(it.dueDate).toLocaleDateString()
                            : "-"}
                        </td>
                      </tr>
                    ))}
                  </React.Fragment>
                ))
              ) : (
                <tr>
                  <td colSpan="12">No Data Available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="pagination">
          <button
            onClick={() => paginate(currentPage - 1)}
            disabled={currentPage === 1}
          >
            Previous
          </button>

          <button
            onClick={() => paginate(1)}
            className={currentPage === 1 ? "active" : ""}
          >
            1
          </button>

          {filteredData.length > 0 &&
            [...Array(
              Math.min(3, Math.ceil(filteredData.length / itemsPerPage) - 1)
            )].map((_, index) => {
              const pageNumber = currentPage + index;
              if (
                pageNumber > 1 &&
                pageNumber <= Math.ceil(filteredData.length / itemsPerPage)
              ) {
                return (
                  <button
                    key={pageNumber}
                    onClick={() => paginate(pageNumber)}
                    className={currentPage === pageNumber ? "active" : ""}
                  >
                    {pageNumber}
                  </button>
                );
              }
              return null;
            })}

          <button
            onClick={() => paginate(currentPage + 1)}
            disabled={
              currentPage === Math.ceil(filteredData.length / itemsPerPage)
            }
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default DcPendingView_Report;
